import React, { createContext, useContext } from "react";

export const ThemeModeContext = createContext({
  themeMode: "system", // "light" | "dark" | "system"
  darkMode: false,     // effective boolean
  toggleDarkMode: () => {},
  setThemeMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
